export type NotificationData = {
  id: string;
  group: string;
  item: string;
  globalTimestampTriggered: number;
  globalTimestampRead: number | undefined;
};

export function isNotificationRead(data: NotificationData): boolean {
  return (data?.globalTimestampRead ?? 0) > data.globalTimestampTriggered;
}
